import { FitnessStatisticsTotals } from "@/model/data/fitnessStatistics/FitnessStatisticsTotals";
import { SourceDestEnum } from "@/model/data/fitnessStatistics/SourceDestEnum";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetFitnessStatisticsReportResData extends ServiceResponseData {
    public statisticsGroupBySourceDest: Map<SourceDestEnum, FitnessStatisticsTotals>;
    public confExists: boolean;

    constructor(response: AxiosResponse) {
        super(response);

        this.statisticsGroupBySourceDest = new Map<SourceDestEnum, FitnessStatisticsTotals>();
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ConfExists) this.confExists = obj.ConfExists;
        if (obj.StatisticsGroupBySourceDest) {
            for (let key in obj.StatisticsGroupBySourceDest) {
                if (key != null && Object.values(SourceDestEnum).includes(key)) {
                    var fitnessStatisticsTotals: FitnessStatisticsTotals = new FitnessStatisticsTotals();
                    fitnessStatisticsTotals.parse(obj.StatisticsGroupBySourceDest[key]);
                    this.statisticsGroupBySourceDest.set(SourceDestEnum[key], fitnessStatisticsTotals);
                }
            }
        }
    }
}
